import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactImage from '../assets/images/contact/contact.jpg';

// External stylesheets
const stylesheets = [
  'https://fonts.googleapis.com/css?family=Jost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CAmiri%3Aregular%2Citalic%2C700%2C700italic%7CAllison%3Aregular&subset=cyrillic%2Clatin%2Clatin-ext%2Carabic%2Cvietnamese&ver=6.0.1',
  'https://fonts.googleapis.com/css?family=Oswald%3A200%2C300%2Cregular%2C500%2C600%2C700%7CMerriweather%3A300%2C300italic%2Cregular%2Citalic%2C700%2C700italic%2C900%2C900italic%7CJost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CMontserrat%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2Cregular%2Citalic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CAllison%3Aregular&subset=cyrillic%2Ccyrillic-ext%2Clatin%2Clatin-ext%2Cvietnamese&ver=6.0.1',
  'https://fonts.googleapis.com/css2?family=Boogaloo&family=Lato:wght@100;300;400;900&display=swap',
  'https://fonts.googleapis.com/css2?family=Handlee&family=Neucha&family=Pacifico&family=Patrick+Hand&family=Patrick+Hand+SC&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sacramento&display=swap',
  'https://fonts.googleapis.com/css2?family=Yellowtail&display=swap',
  '/pettipetti/css/bootstrap.min.css',
  '/bbmirissa/css/style.css',
  '/pettipetti/css/secondary/style.css',
  '/pettipetti/css/vendors.min.css',
  '/pettipetti/css/custom.css',
];

const Contactus = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [message, setMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  // Load Font Awesome and other scripts
  // useEffect(() => {
  //   const faScript = document.createElement('script');
  //   faScript.src = 'https://kit.fontawesome.com/a076d05399.js';
  //   faScript.crossOrigin = 'anonymous';
  //   document.head.appendChild(faScript);

  //   const scripts = [
  //     '../assets/contact.js',
  //     '/bbmirissa/jss/common_scripts.js',
  //     '/bbmirissa/jss/common_functions.js',
  //     '/bbmirissa/jss/slider.js',
  //   ];

  //   const loadedScripts = scripts.map((url) => {
  //     const script = document.createElement('script');
  //     script.src = url;
  //     script.async = true;
  //     document.body.appendChild(script);
  //     return script;
  //   });

  //   return () => {
  //     document.head.removeChild(faScript);
  //     loadedScripts.forEach((script) => {
  //       document.body.removeChild(script);
  //     });
  //   };
  // }, []);

  // Handle form submit (assuming contact.js handles it, but for React, simulate or implement)
  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate submission success
    setShowSuccess(true);
    // Reset form if needed
    setName('');
    setEmail('');
    setMobile('');
    setMessage('');
  };

  return (
    <>
      {stylesheets.map((href, index) => (
        <link key={index} rel="stylesheet" href={href} type="text/css" media="all" />
      ))}
      <title>Contact Us | Banana Bunks Mirissa | Oryza Leisure</title>
      <div
        className="home page-template-default page page-id-14980 theme-hotale gdlr-core-body tourmaster-body woocommerce-no-js hotale-body hotale-body-front hotale-full hotale-with-sticky-navigation hotale-blockquote-style-3 gdlr-core-link-to-lightbox"
        data-home-url="index.html"
      >
        <Navbar />
        <div className="hotale-page-wrapper" id="hotale-page-wrapper">
          <div className="gdlr-core-page-builder-body">
            <div className="gdlr-core-pbf-wrapper" style={{ padding: '300px 0px 160px 0px' }} data-skin="white" id="gdlr-core-wrapper-1">
              <div className="gdlr-core-pbf-background-wrap" style={{ backgroundColor: '#0a0a0a' }}>
                <div
                  className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                  style={{ backgroundImage: `url(${ContactImage})`, backgroundSize: 'cover', backgroundPosition: 'center', opacity: 0.6 }}
                  data-parallax-speed="0"
                ></div>
              </div>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div className="gdlr-core-pbf-element">
                    <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-bottom gdlr-core-item-pdlr">
                      <div className="gdlr-core-title-item-title-wrap">
                        <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test hotale-additional-font" style={{ fontSize: '75px', fontWeight: 600, letterSpacing: '0px', textTransform: 'none', color: '#ffffff' }}>
                          Contact Us<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="gdlr-core-pbf-wrapper" style={{ padding: '30px 0px 20px 0px' }} data-skin="White Text">
              <div className="gdlr-core-pbf-background-wrap" style={{ backgroundColor: '#585550' }}>
                <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" style={{ opacity: 0.5, backgroundSize: 'cover', backgroundPosition: 'center' }} data-parallax-speed="0.2"></div>
              </div>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container contactleft">
                  <div className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first" id="gdlr-core-column-1">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: '50px 20px 0px 20px' }}>
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '40px' }}>
                            <div
                              className="gdlr-core-icon-item-wrap gdlr-core-skin-e-background gdlr-core-icon-item-type-round"
                              style={{ backgroundColor: '#eeb85e', borderRadius: '40px', MozBorderRadius: '40px', WebkitBorderRadius: '40px', padding: '20px 20px 20px 20px' }}
                            >
                              <i className="gdlr-core-icon-item-icon fa fa-phone gdlr-core-skin-e-content" style={{ color: '#585550', fontSize: '40px', minWidth: '40px', minHeight: '40px' }}></i>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{ paddingBottom: '25px' }}>
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{ fontSize: '26px', letterSpacing: '0px', textTransform: 'none', color: '#eeb85e' }}>
                                Call Us<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '0px' }}>
                            <div className="gdlr-core-text-box-item-content" style={{ textTransform: 'none', color: '#eeb85e' }}><p>We are waiting for your call and<br />can't wait to have you at Banana Bunks.</p></div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                            <div className="gdlr-core-text-box-item-content" style={{ fontWeight: 700, textTransform: 'none' }}>
                              <p><a style={{ textDecoration: 'underline' }} href="tel:+94767008800">+94 76 700 8800</a></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-20" id="gdlr-core-column-2">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: '50px 20px 0px 20px' }}>
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '40px' }}>
                            <div
                              className="gdlr-core-icon-item-wrap gdlr-core-skin-e-background gdlr-core-icon-item-type-round"
                              style={{ backgroundColor: '#eeb85e', borderRadius: '40px', MozBorderRadius: '40px', WebkitBorderRadius: '40px', padding: '24px 24px 24px 24px' }}
                            >
                              <i className="gdlr-core-icon-item-icon fa fa-envelope-o gdlr-core-skin-e-content" style={{ color: '#585550', fontSize: '31px', minWidth: '31px', minHeight: '31px' }}></i>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{ paddingBottom: '25px' }}>
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{ fontSize: '26px', letterSpacing: '0px', textTransform: 'none', color: '#eeb85e' }}>
                                Email Us<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '0px' }}>
                            <div className="gdlr-core-text-box-item-content" style={{ textTransform: 'none', color: '#eeb85e' }}><p>Whether it's for you or a group of travellers,<br />drop us an email with all your enquires.</p></div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                            <div className="gdlr-core-text-box-item-content" style={{ fontWeight: 700, textTransform: 'none' }}>
                              <p>
                                <a style={{ textDecoration: 'underline' }} href="mailto:reservations@oryzaleisure.com">
                                  <span>reservations@oryzaleisure.com</span>
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-20" id="gdlr-core-column-3">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ padding: '50px 20px 0px 20px' }}>
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-icon-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '40px' }}>
                            <div
                              className="gdlr-core-icon-item-wrap gdlr-core-skin-e-background gdlr-core-icon-item-type-round"
                              style={{ backgroundColor: '#eeb85e', borderRadius: '40px', MozBorderRadius: '40px', WebkitBorderRadius: '40px', padding: '24px 24px 24px 24px' }}
                            >
                              <i className="gdlr-core-icon-item-icon fa fa-location-arrow gdlr-core-skin-e-content" style={{ color: '#585550', fontSize: '31px', minWidth: '31px', minHeight: '31px' }}></i>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{ paddingBottom: '25px' }}>
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{ fontSize: '26px', letterSpacing: '0px', textTransform: 'none', color: '#eeb85e' }}>
                                Location<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '0px' }}>
                            <div className="gdlr-core-text-box-item-content" style={{ textTransform: 'none', color: '#eeb85e' }}>
                              <p>73 A, Mahena Rd, Bandaramulla,<br />Mirissa 81740
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                            <div className="gdlr-core-text-box-item-content" style={{ fontWeight: 700, textTransform: 'none' }}>
                              <p><a style={{ textDecoration: 'underline' }} href="https://maps.app.goo.gl/uNmmaLvRxa2ouSWz5" target="_blank" rel="noopener noreferrer">View On Google Map</a></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="gdlr-core-pbf-wrapper bbmirissabg" style={{ padding: '90px 0px 35px 0px' }}>
              <div className="gdlr-core-pbf-background-wrap"></div>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" data-skin="Contact Field" id="gdlr-core-column-4">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js" style={{ maxWidth: '760px' }}>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-bottom gdlr-core-item-pdlr green_back_second">
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test contactfont" style={{ fontSize: '39px', fontWeight: 600, letterSpacing: '0px', textTransform: 'none' }}>
                                Leave us your message <span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                            </div>
                            <span className="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption" style={{ fontSize: '19px', fontStyle: 'normal', letterSpacing: '0px', color: '#eeb85e' }}>
                              and we will get back to you.
                            </span>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-contact-form-7-item gdlr-core-item-pdlr gdlr-core-item-pdb">
                            <div role="form" className="wpcf7" id="wpcf7-f1979-p1964-o1" lang="en-US" dir="ltr">
                              <div className="screen-reader-response">
                                <p role="status" aria-live="polite" aria-atomic="true"></p>
                                <ul></ul>
                              </div>
                              <form id="contact" onSubmit={handleSubmit}>
                                <input type="text" name="name" id="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Name*" className="input" required />
                                <input type="text" name="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email*" className="input" required />
                                <input type="text" name="mobile" id="mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="Mobile*" className="input" required />
                                <input type="text" name="hotel" id="hotel" value="bbmirissa" style={{ display: 'none' }} />
                                <textarea name="message" rows="20" cols="20" id="message" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Message*" className="input" required></textarea>
                                <div id="success" className="message success" style={{ display: showSuccess ? 'block' : 'none', backgroundColor: 'green', padding: '10px', color: '#ffffff', marginBottom: '10px', borderRadius: '5px' }}>Your message is successfully sent...</div>
                                <input type="submit" name="submit" value="Submit" className="submit-button" />
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="gdlr-core-pbf-wrapper" style={{ padding: '0px 0px 0px 0px', backgroundColor: '#585550' }}>
              <div className="gdlr-core-pbf-background-wrap"></div>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-pbf-wrapper-full-no-space">
                  <div className="gdlr-core-pbf-element">
                    <div className="gdlr-core-wp-google-map-plugin-item gdlr-core-item-pdlr gdlr-core-item-pdb" style={{ paddingBottom: '0px' }}>
                      <div className="wpgmp_map_container wpgmp-map-1" rel="map1">
                        <iframe title="Google Map of Banana Bunks Mirissa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3968.3728713739874!2d80.46215387609516!3d5.943241294041199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae13f32f0cc5bf1%3A0x7346e1a6e488be44!2sBanana%20Bunks%20Mirissa!5e0!3m2!1sen!2slk!4v1712275261413!5m2!1sen!2slk" width="100%" height="450" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Contactus;